import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { delCart } from "../redux/action";
import "./Cart.css";

const Cart = () => {
  const state = useSelector((state) => state.handleCart);
  const dispatch = useDispatch();

  const [quantities, setQuantities] = useState(state.map(() => 1));

  const handleClose = (itemIndex) => {
    dispatch(delCart(state[itemIndex]));
    setQuantities((prev) => prev.filter((_, index) => index !== itemIndex));
  };

  const increaseQty = (index) => {
    setQuantities((prev) => prev.map((q, i) => (i === index ? q + 1 : q)));
  };

  const decreaseQty = (index) => {
    setQuantities((prev) => prev.map((q, i) => (i === index && q > 1 ? q - 1 : q)));
  };

  const subtotal = state.reduce(
    (sum, item, index) => sum + item.price * quantities[index],
    0
  );

  const cartItems = (cartItem, index) => {
    return (
      <div className="cart-item card shadow-sm mb-4" key={cartItem.id}>
        <div className="card-body d-flex flex-wrap align-items-center">
          <div className="cart-img me-4 text-center">
            <img src={cartItem.image} alt={cartItem.title} />
          </div>

          <div className="flex-grow-1">
            <h5 className="cart-title">{cartItem.title}</h5>
            <p className="text-muted mb-1">{cartItem.category}</p>
            <h6 className="text-primary fw-bold mb-2">₹{cartItem.price}</h6>

            <div className="quantity-controls">
              <button className="btn-qty" onClick={() => decreaseQty(index)}>
                -
              </button>
              <span className="mx-2">{quantities[index]}</span>
              <button className="btn-qty" onClick={() => increaseQty(index)}>
                +
              </button>
            </div>
          </div>

          <div className="ms-auto text-end">
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={() => handleClose(index)}
            >
              <i className="fa fa-trash me-1"></i> Remove
            </button>
          </div>
        </div>
      </div>
    );
  };

  const emptyCart = () => (
    <div className="empty-cart text-center my-5">
      <img
        src="https://cdn-icons-png.flaticon.com/512/2038/2038854.png"
        alt="Empty Cart"
        className="mb-4"
        width="150"
      />
      <h3>Your Cart is Empty</h3>
      <p className="text-muted">Start adding some products to enjoy shopping!</p>
      <NavLink to="/" className="btn btn-primary mt-3">
        Shop Now
      </NavLink>
    </div>
  );

  const checkoutSummary = () => (
    <div className="checkout-summary shadow-sm p-4">
      <h5 className="fw-bold">Order Summary</h5>
      <hr />
      <p className="d-flex justify-content-between">
        <span>Items:</span> <span>{state.length}</span>
      </p>
      <p className="d-flex justify-content-between fw-bold">
        <span>Total:</span> <span>₹{subtotal.toFixed(2)}</span>
      </p>
      <NavLink to="/checkout" className="btn btn-success w-100 mt-3">
        Proceed to Checkout
      </NavLink>
    </div>
  );

  return (
    <div className="cart-container container py-5">
      <h2 className="mb-4 text-center">🛒 Your Shopping Cart</h2>
      {state.length === 0 && emptyCart()}

      <div className="row">
        <div className="col-lg-8">
          {state.length !== 0 && state.map((item, index) => cartItems(item, index))}
        </div>
        <div className="col-lg-4">{state.length !== 0 && checkoutSummary()}</div>
      </div>
    </div>
  );
};

export default Cart;
